export const LogoMark = ({ className = 'h-9 w-9', color = '#9E7D56' }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <path d="M14 31 L32 13 L50 31" stroke={color} strokeWidth="3.5" strokeLinecap="square" />
    <rect x="28" y="31" width="8" height="19" fill={color} />
    <rect x="20" y="47" width="24" height="3" fill={color} />
  </svg>
);

export const Logo = ({ variant = 'dark' }) => {
  const c =
    variant === 'dark'
      ? { mark: '#9E7D56', word: '#2B241C', sub: '#9E7D56' }
      : { mark: '#C5A880', word: '#F7F5F0', sub: '#C5A880' };
  return (
    <span className="flex items-center gap-3">
      <LogoMark color={c.mark} />
      <span className="leading-none text-left">
        <span className={`block font-serif text-xl tracking-[0.18em]`} style={{ color: c.word }}>INVICTO</span>
        <span className="mt-1 block font-mono text-[9px] tracking-[0.5em]" style={{ color: c.sub }}>HOMES INC.</span>
      </span>
    </span>
  );
};
